import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_auth/$companyId/spaces/$spaceId/projects/$projectId/batches/batch/',
)({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/$companyId/spaces/$spaceId/projects/$projectId/batches',
      params: {
        companyId: params.companyId,
        spaceId: params.spaceId,
        projectId: params.projectId,
      },
    })
  },
})
